var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg3({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1766389366994,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 8485,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M512 19.392l426.688 246.336v203.264h-75.776v-130.56L547.648 541.824v355.136l0.192 87.424-35.84 20.288-426.688-246.272V265.728L512 19.392zM161.152 338.304v376.448l310.656 179.52V538.624l-310.656-200.32z m533.248 205.632l61.12 0.064 116.992 298.176-61.12 18.816-31.168-79.488h-111.552l-31.616 79.552L576 842.048 694.4 544zM960 541.056v316.672h-64.768V541.056H960zM723.52 640l-33.344 83.968h66.304L723.52 640zM512 106.88L211.2 280.512l300.928 193.984 300.608-193.792L512 106.944z",
    "p-id": 8486
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3);
export default __webpack_public_path__ + "static/media/3.dd55f6b0b02f293d7634db24f16e9328.svg";
export { ForwardRef as ReactComponent };